<template>
  <div class="whats-this">
    <div class="container">
      <h1>✨ Someone was thinking of U ✨</h1>
      <p class="lead">
        You just received a little surprise — a one-of-a-kind postcard from someone who cares about you.
      </p>

      <div class="info-section">
        <h2>What is this all about?</h2>
        <p>
          <strong>Thinking of U</strong> is a magical way to connect. Every postcard is a surprise —
          designed by AI, inspired by your vibe, and sent with love.
          No previews. No edits. Just a heartfelt little mystery that shows up in your mailbox.
        </p>

        <h2>Keep the magic going 💌</h2>
        <p>
          Sending one is just as fun as receiving one. Pick a vibe, enter a name, and let the magic happen.
        </p>

        <div class="special-offer" role="note" aria-label="Special offer for first-time users">
          💡 <strong>P.S.</strong> First-timers get <strong>50% off</strong> — because everyone deserves to send a little magic.
          <br />
          Use code <strong>FIRSTPURCHASE</strong> at checkout.
        </div>
      </div>

      <div class="actions">
        <router-link to="/create-postcard" class="button primary" aria-label="Create your own postcard">Create Your Own</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsThis',
};
</script>

<style scoped>
.whats-this {
  padding: 60px 20px;
  text-align: center;
  background-color: var(--powder-blue);
  font-family: 'Inter', sans-serif;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background-color: white;
  padding: 48px;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

h1 {
  color: var(--violet-lush);
  font-size: 2.4rem;
  margin-bottom: 20px;
}

.lead {
  font-size: 1.15rem;
  color: #444;
  margin-bottom: 36px;
}

.info-section {
  text-align: left;
  color: #333;
}

.info-section h2 {
  font-size: 1.4rem;
  margin-top: 32px;
  margin-bottom: 8px;
  color: var(--violet-lush);
}

.info-section p {
  font-size: 1rem;
  line-height: 1.65;
  margin-top: 8px;
}

.special-offer {
  background-color: var(--powder-blue);
  border-left: 4px solid var(--hollywood-cerise);
  padding: 16px 20px;
  margin-top: 24px;
  margin-bottom: 32px;
  border-radius: 10px;
  font-size: 1rem;
  color: var(--violet-lush);
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.actions {
  margin-top: 40px;
}

.button {
  padding: 14px 26px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  text-decoration: none;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  background-color: var(--violet-lush);
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  display: inline-block;
}

.button:focus {
  outline: 2px solid var(--hollywood-cerise);
  outline-offset: 3px;
}

.button:hover {
  background-color: #3b1a6f;
  box-shadow: 0 4px 12px rgba(59, 26, 111, 0.3);
}

@media (max-width: 480px) {
  .container {
    padding: 28px 20px;
  }

  h1 {
    font-size: 1.9rem;
  }

  .lead,
  .info-section p {
    font-size: 0.95rem;
  }

  .info-section h2 {
    font-size: 1.2rem;
  }

  .button {
    padding: 12px 22px;
    font-size: 0.95rem;
  }
}
</style>
